<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>图文信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>图文信息列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px;" @clear="gettuwenList" @change="gettuwenList">
            <el-button slot="append" icon="el-icon-search" @click="gettuwenList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="openAddDialog">添加{{ tuwen_type === 1 ? '公告' : '' }}{{ tuwen_type === 2 ? '帮助'
            : '' }}{{
    tuwen_type === 3 ? '通知' : '' }}{{ tuwen_type === 4 ? '轮播图' : '' }}</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two" v-if="show_type === 1 || show_type === 3">
        <el-col :span="24">
          <el-table :data="tuwenList" style="width: 100%" stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label="序号" width="80"></el-table-column>
            <el-table-column prop="tuwen_title" label="标题" w></el-table-column>
            <el-table-column prop="add_time" label="时间" w></el-table-column>
            <el-table-column label="操作" v-if="update_flag === 1">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button v-show="(scope.row.tuwen_name !== 'admin')" type="danger" icon="el-icon-delete" circle
                    size="mini" @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加图文信息部分 -->
      <el-dialog title="添加图文信息" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <!-- <el-form-item label="选择类别" prop="tuwei_leibie">
              <el-select v-model="addForm.tuwen_type" placeholder="选择类别">
                <el-option v-for="item in tuwenTypeList" :key="item.uid" :label="item.type_name"
                  :value="item.type_uid"></el-option>
              </el-select>
            </el-form-item> -->
          <el-form-item label="信息标题" prop="tuwen_title">
            <el-input v-model="addForm.tuwen_title"></el-input>
          </el-form-item>
          <el-form-item label="缩略图">
            <span>* 提示：只能加一张图片</span>
            <div style="height: 100%;">
              <picUpload ref="picUploadRefOne" @backPicUrl="backPicUrl_one" show_type="3" :picsUrl="this.pics_one"
                :key="datekey" max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="缩略图浏览">
            <div style="height: 100%;">
              <picUpload @backPicUrl="backPicUrl_one" show_type="1" :picsUrl="this.addForm.pics_one" :key="datekey"
                max_count="1"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="图片">
            <div style="height: 100%;">
              <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.pics" :key="datekey"
                max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="图片浏览">
            <div style="height: 100%;">
              <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="this.addForm.pics" :key="datekey"
                max_count="10"></picUpload>
            </div>
          </el-form-item>

          <el-form-item label="信息内容" prop="tuwen_memo">
            <el-input class="quill" v-model="addForm.tuwen_memo" type="textarea" rows="10"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addtuwen">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改图文信息信息 -->
      <el-dialog title="修改图文信息信息" :visible.sync="editDialogVisible" width="50%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <!-- <el-form-item label="选择类别" prop="tuwei_leibie">
              <el-select v-model="editForm.tuwen_type" placeholder="选择类别">
                <el-option v-for="item in tuwenTypeList" :key="item.type_uid" :label="item.type_name"
                  :value="item.type_uid"></el-option>
              </el-select>
            </el-form-item> -->

          <el-form-item label="信息标题" prop="tuwen_title">
            <el-input v-model="editForm.tuwen_title"></el-input>
          </el-form-item>
          <el-form-item label="缩略图">
            <span>* 提示：只能加一张图片</span>

            <picUpload ref="picUploadRefOne" @backPicUrl="backPicUrl_one" show_type="3" :picsUrl="this.pics_one"
              :key="datekey" max_count="1"></picUpload>

          </el-form-item>
          <el-form-item label="缩略图浏览">

            <picUpload @backPicUrl="backPicUrl_one" show_type="1" :picsUrl="this.editForm.pics_one" :key="datekey"
              max_count="1"></picUpload>

          </el-form-item>

          <el-form-item label="信息内容" prop="tuwen_memo">
            <el-input v-model="editForm.tuwen_memo" type="textarea" style="height: 300px;" rows="10"> </el-input>
          </el-form-item>

          <el-form-item label="图片">
            <div style="height: 100%;">
              <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.pics" :key="datekey"
                max_count="10"></picUpload>
            </div>
          </el-form-item>
          <el-form-item label="图片浏览">
            <div style="height: 100%;">
              <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="this.editForm.pics" :key="datekey"
                max_count="10"></picUpload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatetuwen">确 定</el-button>
        </span>
      </el-dialog>

    </el-card>
  </div>
</template>
<script>
import picUpload from '../tongyong/pic_com.vue'
export default {
  components: {
    picUpload: picUpload
  },
  props: [
    'tuwen_type', 'update_flag', 'show_type', 'tuwen_uid'
  ],
  // tuwen_type 图文类型 ，显示不同的图文类别
  // update_flag 显示页面类型 1 编辑模式  0为浏览模式
  // show_type 显示模式 1 显示列表 2  显示图片  3 全显模式  
  // tuwen_uid 输入图文编号，直接显示图文信息 显示图片浏览页面
  data() {
    return {
      picsUid: '',
      datekey: Date.now(),
      pic_upload_url: window.sessionStorage.getItem('http_api') + '/upload',
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      // 删除按钮是否可见
      // 获取图文信息列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
                C_type: 'get_list_more',
                C_table_name: 'tuwen_list', // 04 为读取有库存的所有商品
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.tuwen_type // 门店qiye_uid window.sessionStorage.getItem('qiye_uid')
      },
      tuwenList: [],
      // 用于下拉框的数据读取
      jueseList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'tuwen_add',
        tuwen_title: '',
        tuwen_memo: '',
        tuwen_type: 0,
        pics: '',
        pics_one: '',
        qiye_uid: 0
      },
     
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        tuwen_title: [
          { required: true, message: '请输入图文信息名称', trigger: 'blur' },
          { min: 1, max: 50, message: '必须1到10位字符 ', trigger: 'blur' }
        ],
        tuwen_memo: [
          { required: true, message: '请输入图文信息内容', trigger: 'blur' }

        ]

      },
      pics: '',
      pics_one: '',
      editFormRules: {},
      previewPath: '',
      previewDialogVisible: false
    };
  },
  created() {
    this.gettuwenList();
    // console.log(123)
    // console.log(this.tuwen_type, this.show_type, this.update_flag)
  },
  methods: {
    backPicUrl(pics) {
      if (this.addDialogVisible === true) {
        this.addForm.pics = pics
        this.pics = pics
      }

      if (this.editDialogVisible === true) {
        this.editForm.pics = pics
        this.pics = pics
      }
    },
    backPicUrl_one(pics) { // 通过不同的事件，返回不同地方的图片上传数据
      console.log(999, pics)
      if (this.addDialogVisible === true) {
        this.addForm.pics_one = pics
        this.pics_one = pics
      }

      if (this.editDialogVisible === true) {
        this.editForm.pics_one = pics
        this.pics_one = pics
      }
    },
    handlePictureCardPreview(file) {
      this.previewPath = file.response.url
      this.previewDialogVisible = true
    },
    handleRemove(file) {
      console.log(998, file)
      const filePath = file.response.temp_url

      // const i = this.addForm.pics.findIndex(x => console.log(999, x))
      const i = this.addForm.pics.findIndex(x => x.temp_url === filePath)
      this.addForm.pics.splice(i, 1)
      console.log(123, this.addForm.pics)
    },
    handleSuccess(response) {
      const picInfo = { url: response.url, temp_url: response.temp_url }
      this.addForm.pics.push(picInfo)
      console.log(123, this.addForm.pics)
    },
    edithandleSuccess(response) {
      const picInfo = { url: response.url, temp_url: response.temp_url }
      // console.log(123, this.editForm)
      this.editForm.pics.push(picInfo)
    },
    openAddDialog() {
      this.getJueseList()
      this.addDialogVisible = true
    },
    async getJueseList() {
      const { data: res } = await this.$http.get('get_api', {
        params: {
          C_table_name: 'tuwen_juese_list', // 调用普通api get接口 2
          C_type: 'get_list',
          query: '',
          pageNum: 1,
          pageSize: 10
        }
      })
      this.jueseList = JSON.parse(res.data)[0].dataList
    },

    async gettuwenList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      console.log(JSON.parse(res.data))
      this.tuwenList = JSON.parse(res.data)[0].dataList;

      if (!this.tuwenList) return;
      console.log(999, this.tuwenList)
      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.gettuwenList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.gettuwenList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields()

      this.$refs.picUploadRefOne.clearUpload()
      this.$refs.picUploadRefOne.show_pics = [] // 添加部分
      this.$refs.picUploadRefOne.addForm.pics = [] // 显示部分
      // 通过引用 ，把图片管理页addForm.pics 的变量也清空

      this.$refs.picUploadRef.clearUpload()
      this.$refs.picUploadRef.show_pics = [] // 添加部分
      this.$refs.picUploadRef.addForm.pics = [] // 显示部分
      this.addForm.pics_one = '' // 编辑图片显示
      this.addForm.pics = ''

      this.pics = '' // 显示图片
      this.pics_one = ''// 显示图片
    },
    addtuwen() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        // console.log(123)
        this.addForm.tuwen_type = this.tuwen_type
        console.log(this.tuwen_type)
         const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.error('图文重复，添加失败');
          return;
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.gettuwenList();
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.editDialogVisible = true;
      this.tuwenInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async tuwenInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'tuwen_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))

      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
      console.log(1212, this.editForm);
      console.log(this.editForm)
    },
    async updatetuwen() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const updateQueryStr = {
          C_type: 'tuwen_update',
          tuwen_uid: this.editForm.tuwen_uid,
          tuwen_title: this.editForm.tuwen_title,
          tuwen_memo: this.editForm.tuwen_memo,
          pics: this.editForm.pics,
          pics_one: this.editForm.pics_one
        }
        const { data: res } = await this.$http.post('api', updateQueryStr);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.error('图文重复，添加失败');
          return;
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.gettuwenList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async deleteForm(tuwenUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'tuwen_del',
        C_data1: tuwenUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.gettuwenList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}

.quill {
  height: 200px;
}

.tupian_show {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-left: 100px;
}
</style>
